import { birthDateSchema } from '../datetime/birthDate';

export const { iso: Iso, utc: Utc, wallClock: WallClock } = birthDateSchema;
